<template>
  <div>
    <el-button class="base-margin__bottom-10" type="primary" @click="openDialog">
      {{ $t('availableApplications.addApplication') }}
    </el-button>
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <el-table-column :label="$t('availableApplications.id')" prop="id"></el-table-column>
        <el-table-column :label="$t('availableApplications.applicationName')" prop="name"></el-table-column>
        <el-table-column :label="$t('availableApplications.version')" prop="version"></el-table-column>
        <el-table-column :label="$t('availableApplications.applicableSystem')" prop="osRelease"></el-table-column>
        <el-table-column :label="$t('availableApplications.cosAddress')" min-width="300"
                         prop="cosUrl"></el-table-column>
        <el-table-column :label="$t('availableApplications.md5')" prop="hashMd5"></el-table-column>
        <el-table-column
          :label="$t('availableApplications.actions')"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editImage(scope.row)">{{ $t('availableApplications.edit') }}</el-button>
            <el-button type="text" @click="deleteImage(scope.row.id)">{{
                $t('availableApplications.delete')
              }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="formLabelAlign" :model="formLabelAlign" label-width="100px">
        <el-form-item :label="$t('availableApplications.applicationName')" prop="name">
          <el-input v-model="formLabelAlign.name"
                    :placeholder="$t('availableApplications.enterApplicationName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('availableApplications.version')" prop="version">
          <el-input v-model="formLabelAlign.version" :placeholder="$t('availableApplications.enterVersion')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('availableApplications.applicableSystem')" prop="name">
          <el-input v-model="formLabelAlign.osRelease"
                    :placeholder="$t('availableApplications.enterApplicableSystem')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('availableApplications.cosAddress')" prop="cosUrl">
          <el-input v-model="formLabelAlign.cosUrl"
                    :placeholder="$t('availableApplications.enterCosAddress')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('availableApplications.md5')" prop="hashMd5">
          <el-input v-model="formLabelAlign.hashMd5" :placeholder="$t('availableApplications.enterMd5')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createCode">{{ $t('availableApplications.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';
import {Message} from 'element-ui';
import {debounce} from '@/common/utils/utils';

export default {
  name: 'configManagement',
  data() {
    return {
      tableData: [], // 配置列表
      dialogTitle: '',
      dialogVisible: false,
      formLabelAlign: {
        name: '',
        version: '',
        osRelease: '',
        cosUrl: '',
        hashMd5: '',
      },
      dialogType: 'add',
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
    };
  },
  created() {
    this.getList();
  },

  methods: {
    openDialog() {
      this.dialogType = 'add';
      this.dialogTitle = this.$t('availableApplications.addApplication');
      this.formLabelAlign = {
        name: '',
        version: '',
        osRelease: '',
        cosUrl: '',
        hashMd5: '',
      };
      this.dialogVisible = true;
    },

    /**
     * 获取配置列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/admin/describeAvailableApplications?offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        this.tableData = res.applicationList;
        this.tableDataTotal = res.totalCount;
      });
    },

    /**
     * 创建应用
     */
    createCode() {
      debounce(() => {
        if (this.dialogType === 'add') {
          postRequest('/api/eda/common/admin/createAvailableApplications', this.formLabelAlign).then(() => {
            Message.success(this.$t('availableApplications.addApplicationSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        } else {
          postRequest('/api/eda/common/admin/updateAvailableApplications', this.formLabelAlign).then(() => {
            Message.success(this.$t('availableApplications.updateApplicationSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        }
      }, 500);
    },

    /**
     * 更新应用
     */
    editImage(e) {
      this.dialogTitle = this.$t('availableApplications.updateApplication');
      this.dialogType = 'edit';
      this.formLabelAlign = Object.assign({}, e);
      this.dialogVisible = true;
    },

    /**
     * 删除应用
     */
    deleteImage(id) {
      this.$confirm(this.$t('availableApplications.deleteApplicationConfirm'), this.$t('availableApplications.deleteApplication'), {
        confirmButtonText: this.$t('availableApplications.confirm'),
      }).then(() => {
        postRequest('/api/eda/common/admin/deleteAvailableApplications', {id: +id}).then(() => {
          this.getList();
          Message.success(this.$t('availableApplications.deleteApplicationSuccess'));
        });
      })
        .catch(() => {
          // Message.info(this.$t('availableApplications.cancelDelete'));
        });
    },
    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}
</style>
